import React, {useEffect} from "react";
import {ListaMessaggi} from "./ListaMessaggi";
import useAxios from "axios-hooks";
import {API_URL} from "../../../config";
import {Box, Button, CircularProgress} from "@mui/material";

export const MessaggiRifiutati = () => {
    const [{data, loading, error},refetch] = useAxios(`${API_URL}message/blocked`)

    useEffect(() => {
        refetch()
    },[])

    return(
        <Box>
            {loading ? <CircularProgress/> : <ListaMessaggi stato={'rifiutati'} messages={data} refetch={refetch}/>}
        </Box>
    )
}
